<script lang="ts">
	import type { SiteConfig } from '$lib/types';

	interface Props {
		site: SiteConfig;
	}

	let { site }: Props = $props();
</script>

<header class="hero">
	<div class="container hero-inner">
		<div class="hero-copy">
			<p class="eyebrow">{site.profile.eyebrow}</p>
			<h1>{site.home.heroTitle}</h1>
			<p class="hero-lead">{site.home.heroLead}</p>
			<div class="hero-actions">
				<a class="button button-primary" href={site.urls.blog}>Read the notes</a>
				<a class="button button-secondary" href="#verify"
					>Verify a signature, for an email or message.</a
				>
			</div>
		</div>

		{#if site.home.signals?.length}
			<dl class="hero-signals">
				{#each site.home.signals as signal (signal.label)}
					<div class="hero-signal">
						<dt>{signal.label}</dt>
						<dd>{signal.value}</dd>
					</div>
				{/each}
			</dl>
		{/if}
	</div>
</header>
